import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import { SimpleInput } from '../../../../commonComponents/Input/Input';
import { VALID_RANKS } from '../../../../constants/examConstants';

const ratingExams = VALID_RANKS.map((rank) => `${rank} Reg`); // ['E5 Reg', 'E6 Reg']

export default class RatingExamSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.selectAllRatingExam(ratingExams);
  }

  render() {
    return (
      <Row>
        {ratingExams.map((ratingExam) => {
          const displayLabel = ratingExam.split(' ')[0];

          return (
            <Col
              xs={3}
              key={ratingExam}
              className="col-12 col-sm-6 col-md-4 px-0"
            >
              <SimpleInput
                description={displayLabel}
                key={ratingExam}
                type="checkbox"
                initialValue
                value={!!this.props.selectedRatingExam.includes(ratingExam)}
                onChange={() => {
                  this.props.changeRatingExamSelected(ratingExam);
                }}
              />
            </Col>
          );
        })}
      </Row>
    );
  }
}

RatingExamSelector.propTypes = {
  selectAllRatingExam: PropTypes.func.isRequired,
  changeRatingExamSelected: PropTypes.func.isRequired,
  selectedRatingExam: PropTypes.array.isRequired,
};
